export  const readTime = (content) => {
    const wordsPerMinute = 300;
    let result;
    let textLength = content.split(" ").length;
    if (textLength > 0) {
      let value = Math.ceil(textLength / wordsPerMinute);
      result = `~${value} min. read`;
    }
    return result;
  };